import * as Comlink from "comlink";

import { WorkerInterface } from "./types";

let timer: NodeJS.Timeout | null = null;

const startTimer = (callBack: () => unknown, timeout: number) => {
  let baseTime = Date.now();
  const callHandler = () => {
    if (Date.now() - baseTime > timeout) {
      baseTime = Date.now();

      callBack();
    }
  };

  timer = setInterval(callHandler, 1000);
};

const stopTimer = () => timer && clearInterval(timer);

const obj: WorkerInterface = {
  startTimer,
  stopTimer,
};

Comlink.expose(obj);
